var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',{attrs:{"searchQuery":_vm.searchQuery},on:{"update:searchQuery":function($event){_vm.searchQuery = $event}}},[(!_vm.searchQuery)?_c('Hero'):_vm._e(),_c('div',{staticClass:"container-nzidoo"},[_c('HomeProductsList',{attrs:{"randomProducts":_vm.randomProducts,"search-query":_vm.searchQuery}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }